import { render, staticRenderFns } from "./ActivityItem.vue?vue&type=template&id=1977c895&scoped=true"
import script from "./ActivityItem.vue?vue&type=script&lang=ts"
export * from "./ActivityItem.vue?vue&type=script&lang=ts"
import style0 from "./ActivityItem.vue?vue&type=style&index=0&id=1977c895&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1977c895",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1977c895')) {
      api.createRecord('1977c895', component.options)
    } else {
      api.reload('1977c895', component.options)
    }
    module.hot.accept("./ActivityItem.vue?vue&type=template&id=1977c895&scoped=true", function () {
      api.rerender('1977c895', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/new/scheduler/ActivityItem.vue"
export default component.exports